import React from 'react';
import pt from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../utils/font-awesome';
import * as styles from './styles.module.scss';

const Icon = ({ name, size, className, onClick, type, color }) => {
  if (!name) {
    return null;
  }

  return onClick ? (
    <button className={styles.button} onClick={onClick}>
      <FontAwesomeIcon
        icon={[type, name]}
        size={size}
        className={className}
        color={color}
      />
    </button>
  ) : (
    <FontAwesomeIcon
      icon={[type, name]}
      size={size}
      className={className}
      color={color}
    />
  );
};

Icon.propTypes = {
  name: pt.string.isRequired,
  size: pt.string,
  className: pt.string,
  onClick: pt.func,
  type: pt.string,
  color: pt.string,
};

Icon.defaultProps = {
  className: '',
  size: '1x',
  type: 'fal',
  color: '',
};

export default Icon;
